import * as angular from "angular";

let UpcomingInvoice = {
    selector: "vcUpcomingInvoice",
    templateUrl:
        "/angular/components/subscription/upcoming-invoice.component.html",
    bindings: {
        invoice: "=",
        plan: "=",
        title: "=?",
        invoiceLoading: "=?",
    },
    controller: class UpcomingInvoiceController {
        // * bindings for typescript compiler *
        public invoice: any;
        public plan: any;
        public title?: any;
        public invoiceLoading?: any;
        // ************************************

        private __env: any;
        public currency: any;

        constructor(__env: any) {
            this.__env = __env;
        }

        $onInit() {
            this.title = this.title ?? "Invoice";

            if (this.plan.cpcountry == "EU") {
                this.currency = "€";
            } else if (this.plan.cpcountry == "UK") {
                this.currency = "£";
            } else if (
                this.plan.cpcountry == "USA" ||
                this.plan.cpcountry == "US"
            ) {
                this.currency = "$";
            } else {
                this.currency = "$";
            }
        }
    },
};

angular
    .module("subscription", ["LocalStorageModule"])
    .component(UpcomingInvoice.selector, UpcomingInvoice);
